import React, { useState } from 'react';
import { CustomerVService } from '../../services/V2/gozer';
import { convertPhoneNumber, handleChange, handleError, handlePhoneChange, trimField } from '../Shared/Functions';
import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { TextMaskCustom } from '../Shared/PhoneInput';

export function EditContactInfoModal({ hide, show, account, updateAccount, fail, success }) {
    const [form, setForm] = useState<any>({
        ...account.customer,
        homePhoneMask: convertPhoneNumber(account.customer.homePhone),
        workPhoneMask: convertPhoneNumber(account.customer.workPhone),
        cellPhoneMask: convertPhoneNumber(account.customer.cellPhone),
        changeAll: true
    });
    const [submitting, setSubmitting] = useState<boolean>(false);
    const hideReset = () => {
        setSubmitting(false)
        setForm({...account.customer});
        hide();
    }
    const update = () => {
        setSubmitting(true);
        CustomerVService
            .customerVUpdate(account.id ?? "", form.id, form)
            .then(() => {
                success("Contact Updated")
                updateAccount()
                setSubmitting(false);
                hideReset()
            })
            .catch(err => {
                err.message !=="Not Found" && fail(handleError(err))
                setSubmitting(false);
            })

    }

    return (
        <Dialog onClose={hideReset} open={show} fullWidth={true} maxWidth={"md"}>
            <DialogTitle>Update Contact Information</DialogTitle>
            <DialogContent tabIndex={0}>
                {submitting ?
                    <div style={{ minHeight: "500px" }}>
                        <div style={{
                            position: "absolute",
                            left: "50%", top: "50%"
                        }}>
                            <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>
                        </div>
                    </div> : <form>
                        <Grid container>
                            <Grid item xs={12}>
                                <TextField
                                    onChange={e => handleChange(e, form, setForm)}
                                    onBlur={e => trimField(e, form, setForm)}
                                    margin="normal"
                                    name="email"
                                    label="Email"
                                    type="text"
                                    value={form?.email}
                                    fullWidth
                                    autoComplete="email"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl style={{width: "100%", marginBottom: "20px", marginTop: "15px"}}>
                                    <InputLabel htmlFor="homePhone-mask-input">Home Phone</InputLabel>
                                    <OutlinedInput
                                        value={form?.homePhoneMask}
                                        onChange={e => handlePhoneChange(e, form, setForm)}
                                        name="homePhone"
                                        label="Home Phone"
                                        id="homePhone-mask-input"
                                        inputComponent={TextMaskCustom}
                                        fullWidth
                                        style={{width: "100%"}}
                                        autoComplete="tel"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl style={{width: "100%", marginBottom: "20px"}}>
                                    <InputLabel htmlFor="workPhone-mask-input">Work Phone</InputLabel>
                                    <OutlinedInput
                                        value={form?.workPhoneMask}
                                        onChange={e => handlePhoneChange(e, form, setForm)}
                                        name="workPhone"
                                        label="Work Phone"
                                        id="workPhone-mask-input"
                                        inputComponent={TextMaskCustom}
                                        style={{width: "100%"}}
                                        fullWidth
                                        autoComplete="tel"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl style={{width: "100%"}}>
                                    <InputLabel htmlFor="cellPhone-mask-input">Cell Phone</InputLabel>
                                    <OutlinedInput
                                        value={form?.cellPhoneMask}
                                        onChange={e => handlePhoneChange(e, form, setForm)}
                                        name="cellPhone"
                                        label="Cell Phone"
                                        id="cellPhone-mask-input"
                                        inputComponent={TextMaskCustom}
                                        style={{width: "100%"}}
                                        fullWidth
                                        autoComplete="tel"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    onChange={e => handleChange(e, form, setForm)}
                                    onBlur={e => trimField(e, form, setForm)}
                                    margin="normal"
                                    name="street"
                                    label="Street"
                                    type="text"
                                    value={form?.street}
                                    fullWidth
                                    autoComplete="street-address"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    onChange={e => handleChange(e, form, setForm)}
                                    onBlur={e => trimField(e, form, setForm)}
                                    margin="normal"
                                    name="street2"
                                    label="Street 2"
                                    type="text"
                                    value={form?.street2}
                                    fullWidth
                                    autoComplete="street-address"
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    onChange={e => handleChange(e, form, setForm)}
                                    onBlur={e => trimField(e, form, setForm)}
                                    margin="normal"
                                    name="city"
                                    label="City"
                                    type="text"
                                    value={form?.city}
                                    fullWidth
                                    autoComplete="address-level2"
                                />
                            </Grid>
                            <Grid item md={1} xs={0}></Grid>
                            <Grid item md={2} xs={12}>
                                <TextField
                                    onChange={e => handleChange(e, form, setForm)}
                                    onBlur={e => trimField(e, form, setForm)}
                                    margin="normal"
                                    name="state"
                                    label="State"
                                    type="text"
                                    value={form?.state}
                                    fullWidth
                                    autoComplete="address-level1"
                                />
                            </Grid>
                            <Grid item md={1} xs={0}></Grid>
                            <Grid item md={2} xs={12}>
                                <TextField
                                    onChange={e => handleChange(e, form, setForm)}
                                    onBlur={e => trimField(e, form, setForm)}
                                    margin="normal"
                                    name="zip"
                                    label="Zip"
                                    type="text"
                                    value={form?.zip}
                                    fullWidth
                                    autoComplete="postal-code"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    label="Update for all Accounts"
                                    labelPlacement="end"
                                    control={
                                        <Checkbox
                                            checked={form?.changeAll}
                                            onChange={x => setForm({
                                                ...form,
                                                changeAll: x.target.checked
                                            })}
                                            color="primary" />
                                    } />
                            </Grid>
                            <Grid item xs={12}>
                                By selecting "Save" you authorize {account.districtInfo?.name} to send text notifications.
                                Mobile carrier fees may apply.
                            </Grid>
                        </Grid>

                    </form>
                }
            </DialogContent>
            {!submitting &&
                <DialogActions className='contact-info-buttons-group'>
                    <>
                        <Button variant="outlined" onClick={hideReset} style={{marginRight:"10px"}}>Cancel</Button>
                        <Button variant="contained" onClick={update}>Save</Button>
                    </>
                </DialogActions>
            }
        </Dialog>)
}
